<template>
  <div :class="$style.container" infinite-wrapper>
    <container-columns :items="viewData" :cols="2" :gap="10" :getDimensions="getDimensions">
      <template #default="{ item }">
        <img
          :key="item.id"
          v-lazy="item.media_formats.gifpreview.url"
          :alt="item.content_description"
          loading="lazy"
          :class="$style.item"
          v-close-popover
          @click="pick(item)"
        />
      </template>
    </container-columns>
    <infinite-loading :class="$style.infiniteLoading" :identifier="infiniteId" @infinite="infiniteHandler">
      <Spinner slot="spinner" />
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>

<script>
import api from '@/api'
import { debounce } from 'lodash'
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/Spinner'
import ContainerColumns from './ContainerColumns'

const LIMIT = 20

export default {
  name: 'picker-tenor',
  components: {
    ContainerColumns,
    InfiniteLoading,
    Spinner
  },
  props: {
    type: {
      type: String,
      default: 'gifs',
      validator: value => ['gifs', 'stickers'].includes(value)
    },
    query: String
  },
  data () {
    return {
      trending: [],
      searchResult: [],
      nextPaginationToken: '',
      infiniteId: +new Date()
    }
  },
  computed: {
    viewData () {
      return this.query ? this.searchResult : this.trending
    }
  },
  watch: {
    type: 'onTypeChange',
    query: 'onQueryChange'
  },
  methods: {
    getDimensions (gif) {
      const [width, height] = gif.media_formats.gifpreview.dims
      return { width, height }
    },
    pick (gifObj) {
      this.$emit('insert', gifObj)
    },
    onTypeChange () {
      this.nextPaginationToken = ''
      this.infiniteId += 1
      this.trending = []
      this.searchResult = []
    },
    async getTrending () {
      const {
        data: { results, next }
      } = await api.tenor.getGifs({
        limit: LIMIT,
        searchFilter: this.type === 'stickers' ? 'sticker' : '',
        pos: this.nextPaginationToken
      })
      this.nextPaginationToken = next
      this.trending = [...this.trending, ...results]

      return results
    },
    async searchReq () {
      const {
        data: { results, next }
      } = await api.tenor.getGifs({
        q: this.query,
        type: 'search',
        searchFilter: this.type === 'stickers' ? 'sticker' : '',
        pos: this.nextPaginationToken,
        limit: LIMIT
      })
      this.nextPaginationToken = next
      this.searchResult = [...this.searchResult, ...results]

      return results
    },
    onQueryChange: debounce(async function () {
      this.nextPaginationToken = ''
      this.searchResult = []
      if (!this.query) {
        if (!this.trending.length) {
          this.infiniteId += 1
        }
        return
      }
      await this.searchReq()
    }, 500),
    async infiniteHandler ($state) {
      const data = this.query ? await this.searchReq() : await this.getTrending()
      if (data.length) {
        $state.loaded()
      } else {
        $state.complete()
      }
    }
  }
}
</script>

<style module lang="scss">
.container {
  padding: 0 2px;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.item {
  cursor: pointer;
  max-height: min-content;
  max-width: 100%;
  object-fit: contain;
  width: 100%;
}
.infiniteLoading {
  height: 50px;
  padding-top: 10px;
}
</style>
